import { analytics } from '@shared/lib/analytics'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export function AnalyticsRouteTracker() {
  const location = useLocation()

  useEffect(() => {
    analytics.trackPageView(location.pathname)
  }, [location.pathname])

  return null
}
